// extracted by mini-css-extract-plugin
module.exports = {"slider_outer":"style_slider_outer__3PMUX","media_wrapper":"style_media_wrapper__P9P4U","media_item":"style_media_item__kzGFR","slider_media_nav":"style_slider_media_nav__23iuU"};